import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import Images from '../components/Images';
import StyledButton from '../components/StyledButton';
import InstagramIcon from '@mui/icons-material/Instagram';

const Media = () => {
  return (
    <Grid container columnSpacing={{xs: 0, md: 8}} rowSpacing={{xs: 8, md: 0}} sx={{
      width: "100%",
      minHeight: "100vh",
      display: "flex",
      paddingBottom: "88px",
      alignItems: "center",
    }}>
      <Grid item xs={12}>
        <Typography variant="h4" sx={{textAlign: "center", my: {xs: "0", sm: "1rem", md: "2rem"}}}>
        Made with love to light up your personality ✨
        </Typography>
      </Grid>
      <Grid item xs={12} md={6}>
        <Images />
      </Grid>
      <Grid item xs={12} md={6} sx={{textAlign: "center"}}>
        <Typography variant="subtitle2">
          Not only is CyberBadge incredibly eye-catching, but it is also incredibly easy to use. With an elegant application, you can quickly and easily customize the display to show any message or picture you want
        </Typography>
        <Typography variant="subtitle2">
          Whether you want to display your company logo or promote a specific product, CyberBadge makes it easy to get your message across in a way that is both fun and engaging!
        </Typography>
        <StyledButton 
          href="https://www.instagram.com/cyberbadge"
          title="@cyberbadge"
          icon={<InstagramIcon />}
        />
        </Grid>
    </Grid>

    
  )
}

export default Media